import parseTextFromJson from "./parseOldArticle";

export function calculateChunksCount(chunksLength, maxInlineAds = 4, minStep = 2) {
    if (chunksLength < 1) {
        return { adfoxNum: 0, paragraphNum: 0 };
    }
    const inlineAds = Math.min(maxInlineAds, Math.floor(chunksLength / minStep));
    const step = inlineAds > 0 ? Math.max(minStep, Math.floor(chunksLength / (inlineAds + 1))) : 0;
    // +1 за блок перед текстом
    return { adfoxNum: inlineAds + 1, paragraphNum: step };
}

// Обёртки, в которые парсеры/экстракторы (trafilatura, CKEditor) заворачивают
// тело статьи целиком. В такой блок нужно «провалиться», иначе весь текст
// схлопывается в один чанк и не бьётся на абзацы.
const WRAPPER_TAGS = ["DIV", "MAIN", "ARTICLE", "SECTION"];

function hasDirectText(el) {
    return Array.from(el.childNodes).some((node) => node.nodeType === 3 && node.textContent.trim());
}

// keepTags: каждый чанк — готовый блок с собственным тегом (h2, ul, blockquote, p, …), а не
// содержимое без тега. По умолчанию чанк — содержимое, и шаблон сам заворачивает его в <p>.
function extractChunks(root, keepTags = false) {
    // Разворачиваем одиночную обёртку, пока внутри ровно один блок-контейнер
    // и рядом с ним нет собственного текста (иначе потеряли бы этот текст).
    let el = root;
    while (el.children.length === 1 && WRAPPER_TAGS.includes(el.children[0].tagName) && !hasDirectText(el)) {
        el = el.children[0];
    }
    // Собираем чанки по всем узлам (не только элементам): голый текст на
    // верхнем уровне тоже должен попасть в материал, а не пропасть.
    const chunks = [];
    el.childNodes.forEach((node) => {
        if (node.nodeType === 1) {
            chunks.push(keepTags ? node.outerHTML : node.innerHTML);
        } else if (node.nodeType === 3) {
            const text = node.textContent.trim();
            if (text) {
                if (keepTags) {
                    const p = document.createElement("p");
                    p.textContent = text;
                    chunks.push(p.outerHTML);
                } else {
                    chunks.push(text);
                }
            }
        }
    });
    return chunks;
}

// Общий разбор тела новости на чанки-абзацы: строит DOM из `news.content`
// (старый slate-JSON или HTML), разворачивает одиночную обёртку и собирает
// чанки по всем узлам. Используется и в `splitNewsContent`, и в template900,
// чтобы логика не расходилась.
export function contentToChunks(news, keepTags = false) {
    let el = document.createElement("div");
    const content = news.content || "";
    if (content[0] === "{") {
        el.innerHTML = parseTextFromJson(content);
    } else {
        el.innerHTML = content;
    }
    return extractChunks(el, keepTags);
}

export function splitNewsContent(news, maxInlineAds = 4, minStep = 2, keepTags = false) {
    const chunks = contentToChunks(news, keepTags);
    const config = calculateChunksCount(chunks.length, maxInlineAds, minStep);
    if (config.adfoxNum > 0) {
        // первый блок — перед текстом
        chunks.splice(0, 0, "ADFOX");
        // остальные блоки — через каждые step абзацев
        const inlineAds = config.adfoxNum - 1;
        for (let i = 0; i < inlineAds; i++) {
            const insertPosition = 1 + config.paragraphNum * (i + 1) + i;
            if (insertPosition < chunks.length) {
                chunks.splice(insertPosition, 0, "ADFOX");
            }
        }
    }
    return chunks;
}
